import { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { Typography } from 'antd'
import { StyledLayout } from '$globalStyledComponents/Layout'
import { StyledCardContent } from '$pages/serviceprovider/ReceivedRequests/styledComponents'
import Footer from '$components/Footer'
import { fetchAllOrderPartsLists } from '$api/evoAPIs'
import OperatorOrdersTable from './OperatorOrdersTable'

const { Content } = StyledLayout
const { Title } = Typography

const OperatorOrders = () => {
  const { t } = useTranslation()

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  })

  const [sorting, setSorting] = useState({
    field: 'time_stamp',
    order: -1,
  })

  const {
    data: { items: orderPartLists } = {},
    isLoading: orderPartsListsAreLoading,
  } = useQuery(
    [
      'allorderedpartslists_operator',
      {
        pageNr: pagination.current,
        pageSize: pagination.pageSize,
        sorting,
      },
    ],
    fetchAllOrderPartsLists,
    {
      keepPreviousData: true,
      onSuccess: ({ page, total }) => {
        setPagination((prev) => ({ ...prev, current: page, total }))
      },
    },
  )

  const handleTableChange = (newPagination, _filters, newSorter) => {
    setPagination((prev) => ({
      ...prev,
      current: newPagination.current,
      pageSize: newPagination.pageSize,
    }))

    if (newSorter && newSorter.field) {
      setSorting({
        field: newSorter.field,
        order: newSorter.order,
      })
    }
  }

  return (
    <StyledLayout className="layout">
      <Content>
        <Title level={1} style={{ margin: '46px 0' }}>
          {t('operator_orders.title', 'Forward Orders')}
        </Title>
        <StyledCardContent>
          <OperatorOrdersTable
            orderPartLists={orderPartLists}
            loading={orderPartsListsAreLoading}
            pagination={pagination}
            handleTableChange={handleTableChange}
          />
        </StyledCardContent>
      </Content>
      <Footer />
    </StyledLayout>
  )
}

export default OperatorOrders
